import { createAsyncStateHook } from './utils'
import { getEvents, getEvent } from 'src/services/eventServices'

export const useEvents = createAsyncStateHook('event', getEvents)
export const useEvent = createAsyncStateHook('event', getEvent)
